var map = {
	"./labourservices-1.png": "tpP8",
	"./labourservices-10.png": "Rp1y",
	"./labourservices-11.png": "CgTs",
	"./labourservices-2.png": "AOON",
	"./labourservices-3.png": "7yTg",
	"./labourservices-4.png": "Gyiy",
	"./labourservices-5.png": "12kH",
	"./labourservices-6.png": "5KCo",
	"./labourservices-7.png": "rv2m",
	"./labourservices-8.png": "4QKh",
	"./labourservices-9.png": "TxjZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xn4m";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/labourservices\-.*\.png$
// module id = Xn4m
// module chunks = 1